import { colors } from './index'
import configureStore from '../configureStore'
import convertStyleWithMultiplier from './styleHelper'

const listStyles = {
  listItemButton: {
    width: '100%',
    minHeight: 70,
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.white,
  },
  listItemButtonSpacing: {
    padding: 24,
    marginRight: 24,
  },
  listItemButtonSpacingWithIcon: {
    paddingVertical: 16,
    paddingLeft: 16,
    paddingRight: 24,
    marginRight: 24,
  },
  simpleListItemButton: {
    width: '100%',
    justifyContent: 'space-between',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.white,
  },
  simpleListItemButtonSpacing: {
    paddingVertical: 16,
    paddingLeft: 16,
    paddingRight: 24,
    marginRight: 24,
  },
  listItemTextView: {
    flexShrink: 1,
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  listItemTitle: {
    fontSize: 18,
    marginRight: 10,
    marginBottom: 4,
    color: colors.shark_grey,
    lineHeight: 21,
    fontWeight: 'bold',
  },
  simpleListItemText: {
    fontSize: 16,
    marginRight: 10,
    color: colors.shark_grey,
    lineHeight: 19,
  },
  listItemText: {
    fontSize: 16,
    marginRight: 10,
    color: colors.raven_grey,
    lineHeight: 19,
  },
  listItemChevron: {
    flexBasis: 30,
    alignItems: 'flex-start',
    justifyContent: 'center',
    flexGrow: 1,
  },
  sectionPanelView: {
    marginLeft: 17,
    marginRight: 16,
    marginTop: 8,
    marginBottom: 8,
    backgroundColor: colors.white,
    padding: 16,
    borderRadius: 4,
  },
  sectionPanelTitle: {
    fontSize: 18,
    marginRight: 10,
    color: colors.shark_grey,
    lineHeight: 21,
    fontWeight: 'bold',
  },
  sectionPageHeader: {
    marginTop: 16,
  },
  sectionSVGContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 8,
  },
  svgSectionSmallInnerCircle: {
    width: 32,
    height: 32,
    borderRadius: 16,
  },
  svgSectionBiggerInnerCircle: {
    width: 48,
    height: 48,
    borderRadius: 24,
  },
  sectionInnerCircle: {
    backgroundColor: '#E6F0FF',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sectionTextHeader: {
    textAlign: 'center',
    fontSize: 20,
    lineHeight: 24,
    fontWeight: '500',
    marginHorizontal: 16,
    marginVertical: 24,
  },
}

const Sheet = () => {
  const { storedData } = configureStore.getState()
  const { fontMultiplier } = storedData
  return convertStyleWithMultiplier(fontMultiplier || 1, listStyles)
}

export default Sheet()
